const STORAGE_PREFIX = 'risklo_tier_cache';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

function tierCacheKey(email, entitySlug = null) {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized) return null;
  const entity = entitySlug ? String(entitySlug).trim().toLowerCase() : 'vector';
  return `${STORAGE_PREFIX}_${normalized}_${entity}`;
}

export function readTierCache(email, entitySlug = null) {
  const key = tierCacheKey(email, entitySlug);
  if (!key || typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    const cachedAt = Number(parsed.cachedAt);
    if (!Number.isFinite(cachedAt) || Date.now() - cachedAt > MAX_AGE_MS) {
      localStorage.removeItem(key);
      return null;
    }
    return {
      isPro: Boolean(parsed.isPro),
      isMax: Boolean(parsed.isMax),
      isVectorAdmin: Boolean(parsed.isVectorAdmin),
      isBeta: Boolean(parsed.isBeta),
      isDevMode: Boolean(parsed.isDevMode),
      isAdmin: Boolean(parsed.isFullAdmin),
      isFullAdmin: Boolean(parsed.isFullAdmin),
      isVectorAdminPlus: Boolean(parsed.isVectorAdminPlus),
      isSupport: Boolean(parsed.isSupport),
      isSales: Boolean(parsed.isSales),
      entitySlug: parsed.entitySlug || entitySlug || 'vector',
      cachedAt,
    };
  } catch (_err) {
    return null;
  }
}

export function writeTierCache(email, tiers, entitySlug = null) {
  const key = tierCacheKey(email, entitySlug);
  if (!key || !tiers || typeof tiers !== 'object') return;
  const entity = entitySlug || tiers.entitySlug || 'vector';
  try {
    localStorage.setItem(
      key,
      JSON.stringify({
        isPro: Boolean(tiers.isPro),
        isMax: Boolean(tiers.isMax),
        isVectorAdmin: Boolean(tiers.isVectorAdmin),
        isBeta: Boolean(tiers.isBeta),
        isDevMode: Boolean(tiers.isDevMode),
        isAdmin: Boolean(tiers.isFullAdmin),
        isFullAdmin: Boolean(tiers.isFullAdmin),
        isVectorAdminPlus: Boolean(tiers.isVectorAdminPlus),
        isSupport: Boolean(tiers.isSupport),
        isSales: Boolean(tiers.isSales),
        entitySlug: entity,
        cachedAt: Date.now(),
      }),
    );
  } catch (_err) {
    // ignore quota / private mode
  }
}

export function clearTierCache(email, entitySlug = null) {
  if (!email || typeof localStorage === 'undefined') return;
  try {
    if (entitySlug) {
      const key = tierCacheKey(email, entitySlug);
      if (key) localStorage.removeItem(key);
      return;
    }
    const normalized = String(email || '').trim().toLowerCase();
    const prefix = `${STORAGE_PREFIX}_${normalized}_`;
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && k.startsWith(prefix)) keysToRemove.push(k);
    }
    keysToRemove.forEach((k) => localStorage.removeItem(k));
  } catch (_err) {
    // ignore
  }
}
